import React from 'react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';

interface RetryMessageProps {
  onRetry: () => void;
  isLoading?: boolean;
}

const RetryMessage: React.FC<RetryMessageProps> = ({ onRetry, isLoading }) => {
  const { t } = useLanguage();
  
  return (
    <div className="rounded-lg px-4 py-3 max-w-full min-w-0 mb-2 bg-gray-100 text-gray-800 rounded-bl-sm">
      <div className="whitespace-pre-wrap break-words mb-3">
        {t('chat.error.retry.message')}
      </div>
      <Button 
        onClick={onRetry}
        disabled={isLoading}
        variant="default"
        size="sm"
        className="mt-2"
      >
        {t('chat.error.retry.button')}
      </Button>
    </div>
  );
};

export default RetryMessage;
